import { useEffect, useState } from 'react';
import { getSessionEmpresaId } from '../../../../../utils/SessionUser';

const EMPTY = {
    clave: '',
    descripcion: '',
    idEmpresa: null,
};

export default function Modal({ open, mode = 'new', data = null, onClose, onSubmit, inline = false }) {
    const [form, setForm] = useState(EMPTY);
    const [errors, setErrors] = useState({
        clave: '',
        descripcion: '',
    });

    const validateField = (field, rawValue) => {
        const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
        let error = '';

        switch (field) {
            case 'clave':
                if (!value) error = 'La clave es obligatoria.';
                break;
            case 'descripcion':
                if (!value) error = 'La descripción es obligatoria.';
                break;
            default:
                break;
        }

        setErrors((prev) => ({ ...prev, [field]: error }));
        return !error;
    };

    const validateAll = () => {
        const fields = ['clave', 'descripcion'];
        let isValid = true;
        fields.forEach(f => {
            if (!validateField(f, form[f])) isValid = false;
        });
        return isValid;
    };

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
        validateField(field, value);
    };

    useEffect(() => {
        if (mode === 'edit' && data) {
            const filled = {
                clave: data.clave ?? '',
                descripcion: data.descripcion ?? '',
                idEmpresa: data.idEmpresa ?? null,
            };
            setForm(filled);
            validateField('clave', filled.clave);
            validateField('descripcion', filled.descripcion);
        } else {
            setForm(EMPTY);
            setErrors({ clave: '', descripcion: '' });
        }
    }, [mode, data]);

    if (!open) return null;

    const hasErrors = Object.values(errors).some((e) => !!e);
    const isSaveDisabled = !form.clave?.trim() || !form.descripcion?.trim() || hasErrors;

    const errorStyle = {
        color: '#b91c1c',
        fontSize: '.8rem',
        display: 'block',
        marginTop: '4px',
    };

    const Header = (
        <div
            className="roles-topbar"
            style={{
                marginBottom: '0.6rem',
                paddingRight: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: '0 0 auto',
            }}>
            <h3 className="roles-title" style={{ marginRight: 0 }}>
                {mode === 'new' ? 'Nuevo Tipo de Vehículo' : 'Editar Tipo de Vehículo'}
            </h3>
            <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
        </div>
    );

    const Body = (
        <div
            style={{
                paddingLeft: '15%',
                paddingRight: 16,
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '0.8rem',
                overflowY: 'auto',
                flex: '1 1 auto',
                minHeight: 0,
            }}>

            <div style={{ gridColumn: '1 / -1' }}>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Clave:</label>
                <br /><br />
                <input
                    className={`infoField${errors.clave ? ' infoField--error' : ''}`}
                    value={form.clave}
                    onChange={(e) => handleChange('clave', e.target.value)}
                    maxLength={30}
                />
                {errors.clave && <small style={errorStyle}>{errors.clave}</small>}
            </div>

            <div style={{ gridColumn: '1 / -1' }}>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Descripción:</label>
                <br /><br />
                <textarea
                    className={`infoField${errors.descripcion ? ' infoField--error' : ''}`}
                    rows={3}
                    value={form.descripcion}
                    onChange={(e) => handleChange('descripcion', e.target.value)}
                    maxLength={200}
                    style={{ resize: 'vertical' }}
                />
                {errors.descripcion && <small style={errorStyle}>{errors.descripcion}</small>}
            </div>
        </div>
    );

    const Footer = (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '.6rem',
                marginTop: '.8rem',
                paddingRight: 16,
                flex: '0 0 auto',
            }}
        >
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button
                className="btn-action"
                onClick={() => {
                    if (validateAll()) {
                        const sessionEmpresaId = getSessionEmpresaId();
                        const payload = { ...form, idEmpresa: sessionEmpresaId };
                        onSubmit(payload, mode);
                    }
                }}
                disabled={isSaveDisabled}
                style={{
                    opacity: isSaveDisabled ? 0.5 : 1,
                    cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
                }}
            >
                {mode === 'new' ? 'Guardar' : 'Actualizar'}
            </button>
        </div>
    );

    if (inline) {
        return (
            <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                {Header}
                {Body}
                {Footer}
            </div>
        );
    }

    return (
        <div
            className="roles-confirm-overlay"
            role="dialog"
            aria-modal="true"
            style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(15,23,42,.45)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 16,
                zIndex: 1000,
            }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
        >
            <div
                className="roles-confirm-card"
                style={{
                    width: 'min(720px, 96vw)',
                    maxHeight: '85vh',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: '0 10px 30px rgba(0,0,0,.25)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                }}
            >
                {Header}
                {Body}
                {Footer}
            </div>
        </div>
    );
}
